 <template>
    <div class="packageList" style="min-height: 500px;margin-bottom: 200px;">
        <div class="main-container">
            <div class="rule">
                <div class="main-container-head">
                    <ul class="breadcrumb">
                        <!-- <li><a href="javascript:void(0)">酒店预订</a>></li> -->
                        <li> </li>
                    </ul>
                </div>
                <div class="packageList-search">
                    <div class="right" style="width:auto">
                        <div class="content-item input">
                            <i class="iconfont icon-lmy-dingwei"></i>
                            <div @click="isHotCityShow = true;" >{{city}}</div>
                            <HotCity @select="hotCity" :isHotCityShow="isHotCityShow"></HotCity>
                        </div>
                        <div class="right">
                            <div class="btn" @click="searchInit()">
                                搜索
                            </div>
                        </div>
                    </div>
                </div>

                <div class="cnhotel-list-top">
                    <div class="cnhotel-filter-result" v-if="!isLogoLoading">
                        为您搜索到
                        <span class="color-orange">{{total}}</span>
                        个团房套餐
                    </div>
                    <div class="cnhotel-filter-result" v-else>正在为您搜索...</div>
                </div>
                <Loading :isLogoLoading="isLogoLoading"></Loading>
                <div class="packageList-box" v-if="packageList">
                    <div class="packageItem" v-for="item in packageList" @click="routeToDetails(item)">
                        <div class="listImg">
                            <div class="productTag orange">
                                <p>超值团房</p>
                            </div>
                            <img v-if="item.ImageUrl" :src="item.ImageUrl|replaceImgSrc('dfyb1')" class="packageImg" alt="" v-img-error="defaultImg">
                            <img v-else :src="defaultImg">
                            <div class="icon" v-show="item.CityName">
                                <i class="iconfont icon-lmy-dingwei" ></i>
                                 {{item.CityName}}
                            </div>
                        </div>
                        <div class="listPrice">
                            <div class="price">
                              <span v-if="item.Weekdays" style="padding-right: 15px;">
                                平日:￥<span class="number">{{item.Weekdays}}</span> 
                              </span>
                              <span v-if="item.Friday" style="padding-right: 15px;">
                                周五:￥<span class="number">{{item.Friday}}</span> 
                              </span>
                              <span v-if="item.Saturday" style="padding-right: 15px;">
                                周六:￥<span class="number">{{item.Saturday}}</span> 
                              </span>
                            </div>
                        </div>
                        <div class="listText">
                          
                            <div class="productName">
                                {{item.HotelName}} <span v-if="item.RoomName" style="font-weight: normal;padding-left: 5px;font-size: 16px;"> {{item.RoomName}}</span>
                            </div>
                            <div class="productTip">
                              <!-- {{item.Remark}}  -->
                                 <span v-if="item.Count>0">{{item.Count}} 间成团 |</span><span v-else>1 间成团 |</span> <span v-if="item.BreakfastName"> {{item.BreakfastName}} </span> 
                            </div>
                        </div>
                        

                    </div>
                </div>
                <Paginate :pageIndex="Page" :pageTotal="Math.ceil(total/PageSize)" @select="pageSelect" v-if="total>10"></Paginate>
            </div>
        </div>
    </div>
</template>

<script>
import HotCity from "./comm/HotCity.vue"; //热门城市
import Paginate from "./../../common/cmpnt/paginate/paginate.vue"; //分页
import Loading from "./../../common/cmpnt/Loading/Loading.vue"; //缓冲
import defaultPackageImg from "../../assets/img/defaultPackage.jpg";

export default {
  name: "PackageList",
  components: {
    Paginate,
    HotCity,
    Loading
  },
  data: function() {
    return {
      defaultImg: defaultPackageImg,
      isHotCityShow: false,
      isLogoLoading: true,
      city: "全部",
      cityID: "",
      hotCityList:[],
      total: 0,
      packageList: [],
      Page: 1,
      PageSize: 10,
    };
  },
  created: function() {},
  watch: {},
  mounted() {
    document.title='团房预订---订房易';
    this.initData();
    this.getHotCity()
  },

  methods: {
    //打开详情
    routeToDetails(item) {
      this.dao.set('getTFHotel',JSON.stringify(item));
      window.open("#/regimentRoom?HotelId=" + item.HotelId, "_blank");
    },

    //条件搜索
    searchInit() {
      this.Page = 1;
      this.total = 0;
      this.initData();
    },
    hotCity(obj) {
      this.isHotCityShow = false;
      if (obj&&obj.CityName) {
        this.cityID = obj.City_ID;
        this.city = obj.CityName;
      }
      
    },

    // 获取热门城市
    getHotCity() {
      var that = this;
      that
        .getRequest({
          url: that.Api.getTFCity
        })
        .then(res => {
          if (res && res.IsSuccess) {
            var item = {CityName:'全部',City_ID:''}
            that.hotCityList =  JSON.parse(res.Result);
            that.hotCityList.unshift(item)
            that.dao.set('getTFCity',JSON.stringify(that.hotCityList));
            that.$nextTick(() => {
              if(localStorage.getItem('lang')=='t'){
                that.$zh_tran(localStorage.getItem('lang'))
              }         
            })
          } 
        });
    },

    //获取团房数据
    initData() {
      var that = this;
      var params = {
          pageIndex: that.Page,
          pageSize: that.PageSize,
          cityId: that.cityID,
        };
      that.isLogoLoading = true;
      
      that
        .postRequest({
          url: that.Api.getTFHotel,
          params: params
        })
        .then(res => {
            that.isLogoLoading = false;
          if (res && res.IsSuccess && res.Result.length > 0) {
            that.total = res.Total;
            that.packageList = res.Result;
            that.$nextTick(() => {
              if(localStorage.getItem('lang')=='t'){
                that.$zh_tran(localStorage.getItem('lang'))
              }         
            })
          } else {
            that.packageList = "";
            that.total = 0;
            // this.error({
            //   title: "提示",
            //   content: res.Msg || "未获取到相关信息！"
            // });
          }
        });
    },

    // 选择页数
    pageSelect(val) {
      this.total = 0;
      this.Page = val;
      this.initData();
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/regimentRoom/hotelList.vue